import isRebrand from '@/utils/isRebrand';
import { lazy } from 'react';

const GiftCardBalance = lazy(() =>
  import('../components/customers/giftCard/balancePage/GiftCardBalance')
);
const HouseTours = lazy(() =>
  import('../components/customers/pages/houseTours/HouseTours')
);

const ShopAll = lazy(() =>
  import('../components/customers/pages/shopAll/ShopAll')
);

const FrameDetails = lazy(() =>
  import('../components/admin/frame/frameDetails/FrameDetails')
);

const CustomerPhotos = lazy(() =>
  import('../components/customers/customerPhotos/CustomerPhotos')
);

const QADetails = lazy(() =>
  import('../components/admin/qa/qaDetails/QADetails')
);

const FabricDetails = lazy(() =>
  import('../components/admin/fabric/fabricDetails/FabricDetails')
);

const LeaveReview = lazy(() =>
  import('../components/customers/review/leaveReview/Reviews')
);
const LandingReview = lazy(() =>
  import('../components/customers/review/landingReview/Review')
);
const Login = lazy(() => import('../components/login'));
const SignUp = lazy(() => import('../components/signUp'));
const ForgotPassword = lazy(() => import('../components/forgotPassword'));
const ResetPassword = lazy(() => import('../components/resetPassword'));
const NoMatch = lazy(() => import('../components/noMatch'));
const Category = lazy(() => import('../components/admin/category'));
const Subcategory = lazy(() => import('../components/admin/subcategory'));
const Collaborator = lazy(() => import('../components/admin/collaborator'));
const Collection = lazy(() => import('../components/admin/collection'));
const Color = lazy(() => import('../components/admin/color'));
const Leg = lazy(() => import('../components/admin/leg'));
const Waitlist = lazy(() => import('../components/admin/waitlist/Waitlist'));
const CasterLeg = lazy(() => import('../components/admin/casterLeg'));
const ConstructionType = lazy(() => import('../components/admin/constructionType'));
const Lining = lazy(() => import('../components/admin/lining'));
const LibraryImage = lazy(() => import('../components/admin/libraryImage'));
const SupplierAdmin = lazy(() => import('../components/admin/supplier'));
const PtmFabricInventory = lazy(() =>
  import('../components/admin/ptmFabricInventory')
);
const FabricPOTracking = lazy(() =>
  import('../components/admin/fabricPOTracking')
);
const SupplierOrders = lazy(() => import('../components/supplier/order/Order'));
const SupplierOrderDetail = lazy(() =>
  import('../components/supplier/order/orderDetail/OrderDetail')
);
const Material = lazy(() => import('../components/admin/material'));
const Pattern = lazy(() => import('../components/admin/pattern'));
const Scheme = lazy(() => import('../components/admin/scheme'));
const Room = lazy(() => import('../components/admin/room'));
const Survey = lazy(() => import('../components/admin/survey'));
const SurveySuggestion = lazy(() => import('../components/admin/surveySuggestion'));
const Size = lazy(() => import('../components/admin/size'));
const Firmness = lazy(() => import('../components/admin/firmness'));
const ProductAdmin = lazy(() => import('../components/admin/product'));
const BundleAdmin = lazy(() => import('../components/admin/bundle'));
const Order = lazy(() => import('../components/admin/order'));
const Refund = lazy(() => import('../components/admin/refunds'));
const Defect = lazy(() => import('../components/admin/defects'));
const ReturnRequest = lazy(() => import('../components/admin/returnRequests'));
const Return = lazy(() => import('../components/admin/returns'));
const DelayedOrder = lazy(() => import('../components/admin/delayedOrder'));
const UploadImages = lazy(() => import('../components/admin/uploadImages'));
const Test = lazy(() => import('../components/admin/test'));
const Swatch = lazy(() => import('../components/customers/swatch/Swatch'));
const Test2 = lazy(() => import('../components/admin/test2'));
const Fabric = lazy(() => import('../components/admin/fabric'));
const FabricTreatment = lazy(() =>
  import('../components/admin/fabricTreatment')
);
const Device = lazy(() => import('../components/admin/device'));
const Frame = lazy(() => import('../components/admin/frame/Frames'));
const FrameType = lazy(() => import('../components/admin/frameType'));
const Discount = lazy(() => import('../components/admin/discount'));
const Promotion = lazy(() => import('../components/admin/promotion'));
const SaleConfig = lazy(() => import('../components/admin/saleConfig'));
const BannerAsset = lazy(() => import('../components/admin/bannerAsset'));
const BannerTextAdmin = lazy(() => import('../components/admin/bannerText'));
const SaleDetailAdmin = lazy(() => import('../components/admin/saleDetail'));
const GiftCard = lazy(() => import('../components/admin/giftCard'));
const Customer = lazy(() => import('../components/admin/customer'));
const Log = lazy(() => import('../components/admin/log'));
const CustomerDetails = lazy(() =>
  import('../components/admin/customer/customerDetails')
);
const ProductDetails = lazy(() =>
  import('../components/admin/product/productDetails/ProductDetails')
);
const OrderDetails = lazy(() =>
  import('../components/admin/order/orderDetails/OrderDetails')
);
const Review = lazy(() => import('../components/admin/review'));
const QA = lazy(() => import('../components/admin/qa'));
const CustomizeCategory = lazy(() =>
  import('../components/admin/customizeCategory')
);
const ListMerchandiser = lazy(() =>
  import('../components/admin/merchandiser/ListMerchandiser')
);
const CreateMerchandiser = lazy(() =>
  import('../components/admin/merchandiser/CreateMerchandiser')
);
const UpdateMerchandiser = lazy(() =>
  import('../components/admin/merchandiser/UpdateMerchandiser')
);
const ListSeoPages = lazy(() =>
  import('../components/admin/seoPage/ListSeoPages')
);
const CreateSeoPage = lazy(() =>
  import('../components/admin/seoPage/CreateSeoPage')
);
const UpdateSeoPage = lazy(() =>
  import('../components/admin/seoPage/UpdateSeoPage')
);
const BestSellers = lazy(() =>
  import('../components/admin/analytics/bestSellers')
);
const Margins = lazy(() => import('../components/admin/analytics/margins'));
const Returns = lazy(() => import('../components/admin/analytics/returns'));
const OpsMetrics = lazy(() =>
  import('../components/admin/analytics/opsMetrics')
);
const CustomerLifetimeValue = lazy(() =>
  import('../components/admin/analytics/customerLifetimeValue')
);
const SalesPerformance2 = lazy(() =>
  import('../components/admin/analytics/salesPerformance2')
);
const KPIs = lazy(() => import('../components/admin/analytics/kpis'));
const Style = lazy(() => import('../components/admin/style'));
const Redirect = lazy(() => import('../components/admin/redirect'));
const Product = lazy(() => import('../components/customers/product/Product'));

const Cart = lazy(() => import('../components/customers/cart/Cart'));

const Checkout = lazy(() =>
  import('../components/customers/checkout/Checkout')
);
const ConfirmationPage = lazy(() =>
  import('../components/customers/checkout/confirmationPage')
);
const Press = lazy(() => import('../components/customers/pages/press'));
const CovidResponse = lazy(() =>
  import('../components/customers/pages/covidResponse/CovidResponse')
);

const ShippingAndDelivery = lazy(() =>
  import('../components/customers/pages/shippingAndDelivery/ShippingAndDelivery')
);

const Offering = lazy(() =>
  import('../components/customers/pages/offering/Offering')
);

const OurGuarantee = lazy(() =>
  import('../components/customers/pages/ourGuarantee/OurGuarantee')
);

const GiftCardCustomer = lazy(() =>
  import('../components/customers/giftCard/GiftCard')
);

const Trade = lazy(() => import('../components/customers/trade/Trade'));
const TradeSignup = lazy(() => import('../components/customers/trade/signup'));

// const CustomerCategory = lazy(() => import('../components/customers/category'));
const CustomerCategory = lazy(() =>
  import('../components/customers/category/Category')
);
const CollaboratorFabricView = lazy(() =>
  import('../components/customers/collaboratorFabricView/CollaboratorFabricView')
);

const ProductsByFabricView = lazy(() =>
  import('../components/customers/productsByFabricView/CollaboratorFabricView')
);
const ProductFabric = lazy(() =>
  import('../components/customers/productFabric/ProductFabric')
);

const CustomerAccount = lazy(() =>
  import('../components/customers/account/Account')
);

const CustomerCareer = lazy(() =>
  import('../components/customers/pages/career')
);

const TheTeam = lazy(() =>
  import('../components/customers/pages/theTeam/TheTeam')
);

const CustomerAffiliate = lazy(() =>
  import('../components/customers/pages/affiliate/Affiliate')
);

const CustomerAbout = lazy(() =>
  import('../components/customers/pages/about/About')
);

const CustomerTermOfUse = lazy(() =>
  import('../components/customers/pages/termOfUse')
);

const CustomerTermOfUseOld = lazy(() =>
  import('../components/customers/pages/termOfUseOld')
);

const Privacy = lazy(() =>
  import('../components/customers/pages/privacy/Privacy')
);

const PrivacyOld = lazy(() =>
  import('../components/customers/pages/privacyOld/PrivacyOld')
);

const Merchandiser = lazy(() =>
  import('../components/customers/merchandiser/Merchandiser')
);

const CustomerContact = lazy(() =>
  import('../components/customers/pages/contact')
);
const CustomerFaq = lazy(() => import('../components/customers/pages/faq'));
const Search = lazy(() => import('../components/customers/search'));

const QuizOld = lazy(() => import('../components/customers/quiz_old/Quiz'));
const Quiz = lazy(() => import('../components/customers/quiz/Quiz'));

const Bundles = lazy(() => import('../components/customers/bundles/Bundles'));

const Home = lazy(() => isRebrand() ? import('../components/storeFront/home') : import('../components/storeFront/home/'));
const Export = lazy(() => import('../components/admin/analytics/export'));
const ShopByStyle = lazy(() =>
  import('../components/customers/shopByStyle/ShopByStyle')
);
const StylePage = lazy(() =>
  import('../components/customers/shopByStyle/stylePage/StylePage')
);

const routes = [
  {
    path: '/',
    exact: true,
    auth: false,
    roles: [],
    component: Home
  },
  {
    path: '/login',
    exact: true,
    auth: false,
    roles: [],
    component: Login
  },
  {
    path: '/sign-up',
    exact: true,
    auth: false,
    roles: [],
    component: SignUp
  },
  {
    path: '/forgot-password',
    exact: true,
    auth: false,
    roles: [],
    component: ForgotPassword
  },
  {
    path: '/reset-password/:token/:email',
    exact: true,
    auth: false,
    roles: [],
    component: ResetPassword
  },
  {
    path: '/collaborators/:merchandiserSlug/:merchandiserSlug2?',
    exact: true,
    auth: false,
    roles: [],
    component: Merchandiser
  },
  {
    path: '/collaborators/:collaboratorSlug/:fabricSlug',
    exact: true,
    auth: false,
    roles: [],
    component: CollaboratorFabricView
  },
  {
    path: '/categories',
    exact: true,
    auth: false,
    roles: [],
    component: ShopAll
  },
  {
    path: '/home-office-starter-set',
    exact: true,
    auth: false,
    roles: [],
    component: Bundles
  },
  {
    path: '/gift-cards',
    exact: true,
    auth: false,
    roles: [],
    component: GiftCardCustomer
  },
  {
    path: '/house-tours',
    exact: true,
    auth: false,
    roles: [],
    component: HouseTours
  },
  {
    path: '/gift-cards/edit/:id',
    exact: true,
    auth: false,
    roles: [],
    component: GiftCardCustomer
  },
  {
    path: '/gift-cards/balance',
    exact: true,
    auth: false,
    roles: [],
    component: GiftCardBalance
  },
  {
    path: '/styles',
    exact: true,
    auth: true,
    roles: ['5'],
    component: ShopByStyle
  },
  {
    path: '/styles/:styleSlug',
    exact: true,
    auth: true,
    roles: ['5'],
    component: StylePage
  },
  {
    path: '/collections/s/:fabricSlug',
    exact: true,
    auth: false,
    roles: [],
    component: ProductsByFabricView
  },
  {
    path: '/collections/swatch',
    exact: true,
    auth: false,
    roles: [],
    component: Swatch
  },
  {
    path: '/collections/:merchandiserSlug/:merchandiserSlug2?',
    exact: true,
    auth: false,
    roles: [],
    component: Merchandiser
  },
  {
    path: '/categories/:categorySlug/:frameSlug',
    exact: true,
    auth: false,
    roles: [],
    component: ProductFabric
  },
  {
    path: '/c/:categorySlugForSeo/:categorySlug/:frameSlug',
    exact: true,
    auth: false,
    roles: [],
    component: ProductFabric
  },
  {
    path: '/c/:categorySlugForSeo/:categorySlug',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerCategory
  },
  {
    path: '/sale/:categorySlug',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerCategory
  },

  {
    path: '/account/',
    exact: true,
    auth: true,
    roles: ['1', '3', '2', '5', '6'],
    component: CustomerAccount
  },
  {
    path: '/account/:section/',
    exact: true,
    auth: true,
    roles: ['1', '2', '5', '6'],
    component: CustomerAccount
  },
  {
    path: '/account/:section/:orderSection',
    exact: true,
    auth: true,
    roles: ['1', '2', '5', '6'],
    component: CustomerAccount
  },
  {
    path: '/careers',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerCareer
  },
  {
    path: '/theteam',
    exact: true,
    auth: true,
    roles: ['5'],
    component: TheTeam
  },
  {
    path: '/schemes',
    exact: true,
    auth: false,
    roles: ['5'],
    component: Bundles
  },
  {
    path: '/living-room-schemes',
    exact: true,
    auth: false,
    roles: [],
    component: Bundles
  },
  {
    path: '/affiliates',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerAffiliate
  },
  {
    path: '/privacy',
    exact: true,
    auth: false,
    roles: [],
    component: Privacy
  },
  {
    path: '/privacy-previous',
    exact: true,
    auth: false,
    roles: [],
    component: PrivacyOld
  },
  {
    path: '/test-collection',
    exact: true,
    auth: false,
    roles: [],
    component: Merchandiser
  },
  {
    path: '/faq',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerFaq
  },
  {
    path: '/design-services',
    exact: true,
    auth: false,
    roles: [],
    component: Offering
  },
  {
    path: '/contact',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerContact
  },
  {
    path: '/about-us',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerAbout
  },
  {
    path: '/legal',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerTermOfUse
  },
  {
    path: '/legal-previous',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerTermOfUseOld
  },
  {
    path: '/press',
    exact: true,
    auth: false,
    roles: [],
    component: Press
  },
  {
    path: '/covid-response',
    exact: true,
    auth: false,
    roles: [],
    component: CovidResponse
  },
  {
    path: '/shipping-and-delivery',
    exact: true,
    auth: false,
    roles: [],
    component: ShippingAndDelivery
  },
  {
    path: '/our-guarantee',
    exact: true,
    auth: false,
    roles: [],
    component: OurGuarantee
  },
  {
    path: '/account/:section',
    exact: true,
    auth: true,
    roles: ['1', '3', '2', '5'],
    component: CustomerAccount
  },
  {
    path: '/products/:slug/review',
    exact: true,
    auth: false,
    roles: [],
    component: Product
  },
  {
    path: '/products/:slug',
    exact: true,
    auth: false,
    roles: [],
    component: Product
  },
  {
    path: '/cart',
    exact: true,
    auth: false,
    roles: [],
    component: Cart
  },
  {
    path: '/checkout',
    exact: true,
    auth: false,
    roles: [],
    component: Checkout
  },
  {
    path: '/checkout/confirmation/:orderUUID',
    exact: true,
    auth: false,
    roles: [],
    component: ConfirmationPage
  },
  {
    path: '/theinside-irl',
    exact: true,
    auth: false,
    roles: [],
    component: CustomerPhotos
  },
  {
    path: '/reviews/',
    exact: true,
    auth: false,
    roles: [],
    component: LandingReview
  },
  {
    path: '/reviews/:reviewToken',
    exact: true,
    auth: false,
    roles: [],
    component: LeaveReview
  },
  {
    path: '/design-trade-services',
    exact: true,
    auth: false,
    roles: [],
    component: Trade
  },
  {
    path: '/design-trade-services/sign-up',
    exact: true,
    auth: false,
    roles: [],
    component: TradeSignup
  },
  {
    path: '/search',
    exact: true,
    auth: false,
    roles: [],
    component: Search
  },
  {
    path: '/quiz',
    exact: true,
    auth: false,
    roles: [],
    component: Quiz
  },
  {
    path: '/quiz-old/:categoryId?/:frameId?/:redirectToOnClose?',
    exact: true,
    auth: false,
    roles: [],
    component: QuizOld
  },
  {
    path: '/admin/collaborators',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Collaborator
  },
  {
    path: '/admin/collections',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Collection
  },
  {
    path: '/admin/promotions',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Promotion
  },
  {
    path: '/admin/sale-config',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: SaleConfig
  },
  {
    path: '/admin/banner-assets',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: BannerAsset
  },
  {
    path: '/admin/banner-text',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: BannerTextAdmin
  },
  {
    path: '/admin/sale-details',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: SaleDetailAdmin
  },
  {
    path: '/admin/waitlist',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Waitlist
  },
  {
    path: '/admin/colors',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Color
  },
  {
    path: '/admin/legs',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Leg
  },
  {
    path: '/admin/caster-legs',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: CasterLeg
  },
  {
    path: '/admin/construction-types',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: ConstructionType
  },
  {
    path: '/admin/linings',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Lining
  },
  {
    path: '/admin/materials',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Material
  },
  {
    path: '/admin/patterns',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Pattern
  },
  {
    path: '/admin/schemes',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Scheme
  },
  {
    path: '/admin/rooms',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Room
  },
  {
    path: '/admin/survey',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Survey
  },
  {
    path: '/admin/survey-suggestions',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: SurveySuggestion
  },
  {
    path: '/admin/sizes',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Size
  },
  {
    path: '/admin/firmnesses',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Firmness
  },
  {
    path: '/admin/image-library',
    exact: true,
    auth: true,
    roles: ['5'],
    component: LibraryImage
  },
  {
    path: '/admin/suppliers',
    exact: true,
    auth: true,
    roles: ['5'],
    component: SupplierAdmin
  },
  {
    path: '/admin/ptm-fabric-inventory',
    exact: true,
    auth: true,
    roles: ['5'],
    component: PtmFabricInventory
  },
  {
    path: '/admin/fabric-po-tracking',
    exact: true,
    auth: true,
    roles: ['5'],
    component: FabricPOTracking
  },
  {
    path: '/admin/fabrics',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Fabric
  },
  {
    path: '/admin/fabric-treatments',
    exact: true,
    auth: true,
    roles: ['5'],
    component: FabricTreatment
  },
  {
    path: '/admin/products',
    exact: true,
    auth: true,
    roles: ['5'],
    component: ProductAdmin
  },
  {
    path: '/admin/bundles',
    exact: true,
    auth: true,
    roles: ['5'],
    component: BundleAdmin
  },
  {
    path: '/admin/products/:productId',
    exact: true,
    auth: true,
    roles: ['5'],
    component: ProductDetails
  },
  {
    path: '/admin/orders',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Order
  },
  {
    path: '/admin/refunds',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Refund
  },
  {
    path: '/admin/defects',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Defect
  },
  {
    path: '/admin/return-requests',
    exact: true,
    auth: true,
    roles: ['5'],
    component: ReturnRequest
  },
  {
    path: '/admin/returns',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Return
  },
  {
    path: '/admin/orders/delayed',
    exact: true,
    auth: true,
    roles: ['5'],
    component: DelayedOrder
  },
  {
    path: '/admin/orders/:orderId',
    exact: true,
    auth: true,
    roles: ['5'],
    component: OrderDetails
  },
  {
    path: '/admin/reviews',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Review
  },
  {
    path: '/admin/qas',
    exact: true,
    auth: true,
    roles: ['5'],
    component: QA
  },
  {
    path: '/admin/qas/:qaId',
    exact: true,
    auth: true,
    roles: ['5'],
    component: QADetails
  },
  {
    path: '/admin/devices',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Device
  },
  {
    path: '/dev',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Test
  },
  {
    path: '/admin/frames',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Frame
  },
  {
    path: '/admin/frame-types',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: FrameType
  },
  {
    path: '/admin/frames/:frameId',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: FrameDetails
  },
  {
    path: '/admin/fabrics/:fabricId',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: FabricDetails
  },
  {
    path: '/admin/customers',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Customer
  },
  {
    path: '/admin/customers/:customerId',
    exact: true,
    auth: true,
    roles: ['5'],
    component: CustomerDetails
  },
  {
    path: '/admin/logs',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Log
  },
  {
    path: '/admin/upload-images',
    exact: true,
    auth: true,
    roles: ['5'],
    component: UploadImages
  },
  {
    path: '/admin/discounts',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Discount
  },
  {
    path: '/admin/gift-cards',
    exact: true,
    auth: true,
    roles: ['5'],
    component: GiftCard
  },
  {
    path: '/admin/styles',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Style
  },
  {
    path: '/admin/redirects',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Redirect
  },
  {
    path: '/admin/categories',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Category
  },
  {
    path: '/admin/subcategories',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Subcategory
  },
  {
    path: '/admin/customize-categories',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: CustomizeCategory
  },
  {
    path: '/admin/merchandiser',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: ListMerchandiser
  },
  {
    path: '/admin/merchandiser/create',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: CreateMerchandiser
  },
  {
    path: '/admin/merchandiser/:id',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: UpdateMerchandiser
  },
  {
    path: '/admin/seo-pages',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: ListSeoPages
  },
  {
    path: '/admin/seo-pages/create',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: CreateSeoPage
  },
  {
    path: '/admin/seo-pages/:id',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: UpdateSeoPage
  },
  {
    path: '/admin/analytics/dashboard',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: SalesPerformance2
  },
  {
    path: '/admin/analytics/kpis',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: KPIs
  },
  {
    path: '/admin/analytics/best-sellers',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: BestSellers
  },
  {
    path: '/admin/analytics/returns',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Returns
  },
  {
    path: '/admin/analytics/ops-metrics',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: OpsMetrics
  },
  {
    path: '/admin/analytics/customer-lifetime-value',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: CustomerLifetimeValue
  },
  {
    path: '/admin/analytics/margins',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Margins
  },
  {
    path: '/admin/analytics/exports',
    exact: true,
    auth: true,
    roles: ['5'],
    deny_cx_agents_access: true,
    component: Export
  },
  {
    path: '/dev',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Test
  },
  {
    path: '/fabric-swatches',
    exact: true,
    auth: false,
    roles: [],
    component: Swatch
  },
  {
    path: '/wallpaper-swatches',
    exact: true,
    auth: false,
    roles: [],
    component: Swatch
  },
  {
    path: '/admin/test2',
    exact: true,
    auth: true,
    roles: ['5'],
    component: Test2
  },
  {
    path: '/supplier/orders',
    exact: true,
    auth: true,
    roles: ['3', '5'],
    deny_cx_agents_access: true,
    component: SupplierOrders
  },
  {
    path: '/supplier/orders/:orderId',
    exact: true,
    auth: true,
    roles: ['3', '5'],
    component: SupplierOrderDetail
  },
  {
    path: '/:notFound',
    exact: true,
    auth: false,
    roles: [],
    component: NoMatch
  }
];

export default routes;
